import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';

@Component({
  selector: 'app-add-service-category',
  templateUrl: './add-service-category.component.html',
  styleUrls: ['./add-service-category.component.css']
})
export class AddServiceCategoryComponent implements OnInit {

  @ViewChild('fileInput') fileInput;

  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  headerLabel: string;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) { }
  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }
      if (p.service_category_id) {
        this.headerLabel = 'Edit';
        this.getservicecategory(p.service_category_id);
      } else {
        this.headerLabel = 'New';
        // this.getservicecategory('');
      }
    }, error => { alert('Network Error params API'); });
  }

  getservicecategory(service_category_id) {
    this.loginservice.getservicecategorysAddEdit(service_category_id, '1', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            if (service_category_id) {
              this.model = data;
            }
            this.showLoader = false;
          } else {
            this.model = [];
            // this._flashMessagesService.show('No Vendors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error getservicecategorysAddEdit API');
          this.showLoader = false;
        });
  }

  saveiservicecategory() {
    this.showLoader = true;
    this.model['type'] = 1;
    this.loginservice.saveiservicecategory(this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
            this.showLoader = false;
            this.router.navigate(['service-category']);
          } else if (data['status'] === 'duplicate') {
            this._flashMessagesService.show(data['msg'], { cssClass: 'alert-danger' });
            this.showLoader = false;
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error saveiservicecategory API');
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/add-service-category/add-service-category.component.ts